import React, { Dispatch, useCallback } from 'react';

import { close } from '@/assets/icons';
import { Scrollbar } from '@/components/Scrollbar';
import { GetVideoQuery } from '@/graphql';
import { formatTimeRemaining } from '@/helpers/formatTimeRemaining';
import differenceInMilliseconds from 'date-fns/differenceInMilliseconds';
import { pathOr } from 'ramda';

// import { useDevotionStore } from '../../stateManagement';
import { IconButton } from '../IconButton';
import { UpNext } from '../UpNext/UpNext';
// import { UpNext } from './UpNext/UpNext';
import { VideoSynopsis } from '../VideoSynopsis';
// import { DevotionTextToggle } from './Devotion/DevotionTextToggle';
// import { TimeRemaining } from './Devotion/TimeRemaining';
import styles from './InfoArea.module.scss';

interface InfoAreaProps {
	onCloseClick: () => void;
	pageLoading: boolean;
	// isDevotion: boolean;
	video: GetVideoQuery['getVideo'];
	// devotionTextShown: boolean;
	// setDevotionTextShown: Dispatch<boolean>;
}

export const InfoArea: React.FC<InfoAreaProps> = ({
	onCloseClick,
	pageLoading,
	// isDevotion,
	video,
	// devotionTextShown,
	// setDevotionTextShown,
}) => {
	// const storedDevotionVideoId = useDevotionStore(
	// 	useCallback((state) => state.devotion?.video.id, []),
	// );
	// const endDay = useDevotionStore(useCallback((state) => state.endDay, []));

	// let remainingDevotionTime = '';
	// if (video?.id === storedDevotionVideoId) {
	// 	remainingDevotionTime = `${formatTimeRemaining(
	// 		differenceInMilliseconds(endDay, new Date()),
	// 	)} remaining`;
	// } else {
	// 	remainingDevotionTime = 'This devotion has ended';
	// }

	const videoCollections = pathOr<
		NonNullable<
			NonNullable<GetVideoQuery['getVideo']['videoCollection']>['videos']
		>
	>([], ['videoCollection', 'videos'], video);

	return (
		<>
			<div className={styles['info-area__top']}>
				<div className={styles['info-area__close-video']}>
					<IconButton
						icon={close}
						color="transparent"
						onClick={onCloseClick}
						size="medium"
					/>
				</div>
				{!pageLoading && (
					<>
						{/* {isDevotion && (
							<h2 className={styles['info-area__devotion-title']}>
								{video?.devotionTitle}
							</h2>
						)} */}
						<h1 className={styles['info-area__title']}>
							{video.name}
						</h1>
						<Scrollbar className={styles['info-area__content']}>
							<VideoSynopsis
								synopsisShown
								authorName={video.contributor?.name ?? 'Asaph'}
								authorRole={
									video.contributor?.role ??
									'The Worship Team Platform'
								}
								description={video.description}
								authorAvatar={
									video.contributor?.imageUrl ?? undefined
								}
								mode="dark"
								// TOADO RB: we don't support it
								// tags={['Hello', 'World']}
							/>
							{/* {isDevotion && (
								<>
									<div
										className={
											styles[
												'info-area__devotion-time-remaining'
											]
										}
									>
										<TimeRemaining
											value={remainingDevotionTime}
											ended={
												video?.id !==
												storedDevotionVideoId
											}
										/>
									</div>
									<div
										className={
											styles[
												'info-area__devotion-text-button'
											]
										}
									>
										<DevotionTextToggle
											devotionTextShown={
												devotionTextShown
											}
											setDevotionTextShown={
												setDevotionTextShown
											}
										/>
									</div>
								</>
							)} */}
						</Scrollbar>
					</>
				)}
			</div>
			{videoCollections.length > 1 && (
				<div className={styles['info-area__bottom']}>
					<UpNext
						variant="desktop"
						videos={videoCollections}
						currentlyWatched={video?.id}
						collectionName={pathOr(
							'',
							['videoCollections', 'name'],
							video,
						)}
					/>
				</div>
			)}
		</>
	);
};
